import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Head from '../components/Head';
import Foot from '../components/Foot';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const apiUrl = process.env.REACT_APP_API_URL;

function Awards() {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  // useEffect(() => {
  //   const fetchAwards = async () => {
  //     try {
  //       const response = await axios.get(`${apiUrl}/api/public/awards`);
  //       if (response.data.success) {
  //         setAwards(response.data.awards);
  //       } else {
  //         setError(response.data.message || 'Failed to load awards.');
  //       }
  //     } catch (err) {
  //       setError('Error fetching awards. Please try again later.');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchAwards();
  // }, []);

  useEffect(() => {
  setAwards([
    { id: 1, title: 'Best Education & Academic Excellence Award', imagepath: 'assets/img/awards/1big.png' },
    { id: 2, title: 'Global Excellence Award', imagepath: 'assets/img/awards/2big.png' },
  ]);
  setLoading(false);
}, []);

  const openLightbox = (imageUrl, index) => {
    setPhotoIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  return (
    <>
      <Head />
      {/* Start Hero */}
      <section className="common-page-hero">
        <img
          src="assets/img/bg/common-bg.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginTop: 100 }}>
              <p className="ak-section-subtitle animation-title">Discover</p>
              <h2 className="ak-section-title animation-title">Awards</h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Discover / Awards
            </p>
          </div>
          <a href="" className="phone-number">
            +91 90486 48777
          </a>
        </div>
      </section>
      {/* End Hero */}
      {/* Start All Services */}
      <div className="ak-height-60 ak-height-lg-50" />
      {/* <section>
        <div className="container">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {loading ? (
              <div className="col-12 text-center">Loading awards...</div>
            ) : error ? (
              <div className="col-12 text-center text-danger">{error}</div>
            ) : awards.length === 0 ? (
              <div className="col-12 text-center text-warning">No awards found.</div>
            ) : (
              awards.map((award, index) => (
                <div className="col" key={award.id}>
                  <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
                    <div
                      className="image-thumbnail cursor-pointer"
                      onClick={() => openLightbox(`${apiUrl}/${award.imagepath}`, index)}
                    >
                      <img
                        src={`${apiUrl}/${award.imagepath}`}
                        alt={award.title}
                        className="w-full h-64 object-cover"
                      />
                      <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                        <span className="text-white font-semibold">View Image</span>
                      </div>
                    </div>
                    <div className="p-4">
                      <h5 className="text-lg font-semibold">{award.title}</h5>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section> */}

      <>
  {/* Start All Services*/}
  <div className="ak-height-60 ak-height-lg-50" />
  <section>
    <div className="container">
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">


        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/awards/1big.png')"
            >
              <img
                src="assets/img/awards/1small.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">
                Best Education &amp; Academic Excellence Award{" "}
              </h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>


        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/awards/2big.png')"
            >
              <img
                src="assets/img/awards/2small.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">Global Excellence Award</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>


 <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/awards/3big.png')"
            >
              <img
                src="assets/img/awards/3small.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">UAE's Next Mastermind Award</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>


        <br />
      </div>
    </div>
  </section>
  {/* End All Services*/}
  <div className="ak-height-20 ak-height-lg-30" />
</>

      {/* End All Services */}
      <div className="ak-height-20 ak-height-lg-30" />
      <Foot />


{/* Lightbox */}
  <div className="lightbox" id="lightbox">
    <span className="lightbox-close" onclick="closeLightbox()">
      ×
    </span>
    <img id="lightbox-image" src="" alt="Lightbox Image" />
  </div>

  
      {/* {isLightboxOpen && (
        <Lightbox
          mainSrc={`${apiUrl}/${awards[photoIndex].imagepath}`}
          nextSrc={`${apiUrl}/${awards[(photoIndex + 1) % awards.length].imagepath}`}
          prevSrc={`${apiUrl}/${awards[(photoIndex + awards.length - 1) % awards.length].imagepath}`}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + awards.length - 1) % awards.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % awards.length)
          }
          imageTitle={awards[photoIndex].title}
          imageCaption="Award Image"
        />
      )} */}
    </>
  );
}

export default Awards;